import { useEffect } from "react";
import { formatDateTimeEsCO } from "../../../helpers";
import { usePatientSurgeryStore } from "../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";
import { translationsPatientSurgeryState } from "../../data";

export const PatientSurgeryTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgeries,
    filters,
    pagination,

    // Methods
    getPatientSurgery,
  } = usePatientSurgeryStore();
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (patientSurgeries.data.length === 0) {
      getPatientSurgery({ filters, pagination });
    }
  }, [patientSurgeries.data, getPatientSurgery, filters, pagination]);

  return (
    <>
      {patientSurgeries.isLoading && <LoadingData />}
      {patientSurgeries.message?.type === "error" && (
        <ErrorMessage>{patientSurgeries.message.text}</ErrorMessage>
      )}

      <div className="table-responsive shadow rounded">
        <table className="table table-borderless">
          <thead>
            <tr>
              <th>Apellidos</th>
              <th>Nombres</th>
              <th>Procedimiento</th>
              <th>Fecha</th>
              <th>Riesgo</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {patientSurgeries.data.map((patientSurgery) => {
              const { firstName, lastName } = patientSurgery.patient.user;
              const { title } = patientSurgery.procedure.procedure;
              const { createdAt, track, state } = patientSurgery;

              return (
                <tr key={patientSurgery.id}>
                  <td className="py-3">{firstName}</td>
                  <td className="py-3">{lastName}</td>
                  <td className="py-3">{title}</td>
                  <td className="py-3">{formatDateTimeEsCO(createdAt)}</td>
                  <td className="py-3">
                    <h6>
                      <span className="badge bg-light text-dark">
                        {track || "PENDIENTE"}
                      </span>
                    </h6>
                  </td>
                  <td className="py-3">
                    {translationsPatientSurgeryState[state] || state}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};
